import {call, put, select, takeLatest} from "redux-saga/effects";
import {
  getEthernetConfigurationsAsync,
  editEthernetConfigurationsAsync,
  getPortForwardingConfigurationsAsync,
  editPortForwardingConfigurationsAsync,
  resetPFConfigAsync,
  getModbusTcpIpAsync,
  saveModbusTcpIpAsync,
  getCellularModemAsync,
  saveCellularModemAsync,
  changeEmailTransmissionConfigAsync,
  getAquaticGroupProfilesAsync,
  addEditAquaticGroupProfileAsync,
} from "../AsyncActions/toolsTab.async";
import {getSelectedController} from "../Selectors/controllers.selectors";
import * as actions from "../action.constants";

function* requestEthernetConfig() {
  try {
    const selectedController = yield select(getSelectedController);
    const response = yield call(getEthernetConfigurationsAsync, {
      mac_id: selectedController?.mac,
    });
    if (response?.data) {
      yield put({
        type: actions.STORE_ETHERNET_CONFIG,
        payload: response?.data?.data,
      });
    }
  } catch (e) {
    /* empty */
  }
}

function* requestPortFwd() {
  try {
    const selectedController = yield select(getSelectedController);
    const response = yield call(getPortForwardingConfigurationsAsync, {
      mac_id: selectedController?.mac,
    });
    if (response?.data) {
      yield put({
        type: actions.STORE_PORT_FORWARDING_CONFIGURATIONS,
        payload: response?.data?.data,
      });
    }
  } catch (e) {
    /* empty */
  }
}

function* editEthernetRequest(action = {}) {
  const {requestPayload = {}, callback = () => {}} = action;
  try {
    const selectedController = yield select(getSelectedController);
    if (selectedController.mac) {
      const response = yield call(
        editEthernetConfigurationsAsync,
        {mac_id: selectedController?.mac},
        requestPayload
      );
      if (response?.data) {
        callback();
        yield call(requestEthernetConfig);
      }
    }
  } catch (e) {
    /* empty */
  }
}

function* editPortForwardingRequest(action = {}) {
  const {requestPayload, callback = () => {}} = action;
  try {
    const selectedController = yield select(getSelectedController);
    if (selectedController?.mac) {
      const response = yield call(
        editPortForwardingConfigurationsAsync,
        {mac_id: selectedController?.mac},
        requestPayload
      );
      if (response?.data) {
        callback();
      }
    }
  } catch (e) {
    /* empty */
  }
}

function* resetPFConfig() {
  const selectedController = yield select(getSelectedController);
  try {
    const response = yield call(resetPFConfigAsync, {
      mac_id: selectedController?.mac,
    });
    if (response?.data) {
      yield put({type: actions.REQUEST_SYSTEM_PROPERTIES_SAGA});
      yield call(requestPortFwd);
    }
  } catch (_e) {
    //
  }
}

function* getModbusTcpRequest() {
  const selectedController = yield select(getSelectedController);
  try {
    const response = yield call(getModbusTcpIpAsync, {
      mac_id: selectedController?.mac,
    });
    if (response?.data) {
      yield put({
        type: actions.STORE_MODBUS_TCP_IP,
        payload: response?.data?.data,
      });
    }
  } catch (_e) {
    //
  }
}

function* saveModbusTcpRequest(action) {
  const selectedController = yield select(getSelectedController);
  try {
    const response = yield call(
      saveModbusTcpIpAsync,
      {mac_id: selectedController?.mac},
      action?.payload
    );
    if (response?.data) {
      yield call(getModbusTcpRequest);
    }
  } catch (_e) {
    //
  }
}

function* getCellularModemRequest() {
  const selectedController = yield select(getSelectedController);
  try {
    const response = yield call(getCellularModemAsync, {
      mac_id: selectedController?.mac,
    });
    if (response?.data) {
      yield put({
        type: actions.STORE_CELLULAR_MODEM,
        payload: response?.data?.data,
      });
    }
  } catch (_e) {
    //
  }
}

function* saveCellularModemRequest(action) {
  const selectedController = yield select(getSelectedController);
  try {
    const response = yield call(
      saveCellularModemAsync,
      {mac_id: selectedController?.mac},
      action?.payload
    );
    if (response?.data) {
      yield call(getCellularModemRequest);
    }
  } catch (_e) {
    //
  }
}

function* changeEmailTransmissionConfig(action = {}) {
  const {payload = {}} = action;
  const selectedController = yield select(getSelectedController);
  try {
    const response = yield call(changeEmailTransmissionConfigAsync, {
      mac: selectedController?.mac,
      payload,
    });
    if (response?.data) {
      yield put({type: actions.REQUEST_SYSTEM_PROPERTIES_SAGA, trackPromise: true});
    }
  } catch (_e) {
    //
  }
}

function* getAquaticGroupProfiles() {
  try {
    const selectedController = yield select(getSelectedController);
    const response = yield call(getAquaticGroupProfilesAsync, {
      controller_pk: selectedController.mac,
    });
    if (response) {
      yield put({
        type: actions.STORE_AQUATIC_GROUP_PROFILES,
        payload: response.data || {},
      });
    }
  } catch (_e) {
    return _e;
  }
}

function* addEditAquaticGroupProfileSaga(action = {}) {
  const {payload, callback = () => {}} = action;
  const selectedController = yield select(getSelectedController);
  try {
    const response = yield call(addEditAquaticGroupProfileAsync, {
      ...payload,
      inventory: selectedController.mac,
    });
    if (response) {
      callback();
      yield call(getAquaticGroupProfiles);
    }
  } catch (_e) {
    return _e;
  }
}

export function* ToolsTabSaga() {
  yield takeLatest(actions.REQUEST_ETHERNET_CONFIG, requestEthernetConfig);
  yield takeLatest(actions.REQUEST_EDIT_ETHERNET_SAGA, editEthernetRequest);
  yield takeLatest(actions.REQUEST_PORT_FORWARDING_CONFIGURATIONS, requestPortFwd);
  yield takeLatest(actions.REQUEST_EDIT_PORT_FORWARDING_SAGA, editPortForwardingRequest);
  yield takeLatest(actions.REQUEST_RESET_PF_CONFIG, resetPFConfig);
  yield takeLatest(actions.REQUEST_MODBUS_TCP_IP, getModbusTcpRequest);
  yield takeLatest(actions.SAVE_MODBUS_TCP_IP, saveModbusTcpRequest);
  yield takeLatest(actions.REQUEST_CELLULAR_MODEM, getCellularModemRequest);
  yield takeLatest(actions.SAVE_CELLULAR_MODEM, saveCellularModemRequest);
  yield takeLatest(
    actions.CHANGE_EMAIL_TRANSMISSION_CONFIG,
    changeEmailTransmissionConfig
  );
  yield takeLatest(actions.REQUEST_AQUATIC_GROUP_PROFILES, getAquaticGroupProfiles);
  yield takeLatest(
    actions.ADD_EDIT_AQUATIC_GROUP_PROFILE,
    addEditAquaticGroupProfileSaga
  );
}
